module.exports = __webpack_public_path__ + "img/img_manual2_4.d7b2b52f.jpg";